const per_device_initial = {};
const per_device_reducer = (state = per_device_initial, action) => {
    switch (action.type) {
        case 'SET_Z3K_TARGET_TEMP':
            return {
                ...state,
                [action.object_id]: {
                    target_temp: action.target_temp,
                    request_time: action.request_time,
                    fail: false,
                    fail_message: '',
                },
            };
        case 'ON_Z3K_TARGET_TEMP_CONFIRMED':
            if (state[action.object_id]?.request_time > action.request_time)
                return state;
            else {
                const { [action.object_id]: _, ...rest } = state;
                return rest;
            }
        case 'SET_Z3K_TARGET_TEMP_FAIL':
            return {
                ...state,
                [action.object_id]: {
                    target_temp: action.target_temp,
                    request_time: action.request_time,
                    fail: true,
                    fail_message: action.error_message,
                },
            };
        case 'SET_Z3K_TARGET_TEMP_RESET':
            return {
                ...state,
                [action.object_id]: {
                    target_temp: action.target_temp,
                    request_time: action.request_time,
                    fail: false,
                    fail_message: '',
                },
            };
        default:
            return state;
    }
};
const initial_state = {
    by_device_id: {},
};
export const z3k_target_temp_reducer = (state = initial_state, action) => {
    switch (action.type) {
        case 'SET_Z3K_TARGET_TEMP':
        case 'ON_Z3K_TARGET_TEMP_CONFIRMED':
        case 'SET_Z3K_TARGET_TEMP_FAIL':
        case 'SET_Z3K_TARGET_TEMP_RESET':
            return {
                by_device_id: {
                    ...state.by_device_id,
                    [action.device_id]: per_device_reducer(state.by_device_id[action.device_id], action),
                },
            };
        default:
            return state;
    }
};
